import { render, staticRenderFns } from "./TemplateItemMenu.vue?vue&type=template&id=5a452f13&scoped=true&"
import script from "./TemplateItemMenu.vue?vue&type=script&lang=js&"
export * from "./TemplateItemMenu.vue?vue&type=script&lang=js&"
import style0 from "./TemplateItemMenu.vue?vue&type=style&index=0&id=5a452f13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a452f13",
  null
  
)

export default component.exports